import { Controller } from "stimulus";
import _ from 'lodash';
import morphDom from 'morphdom';
import Utility from 'classes/Utility';
import { delegate } from 'tippy.js';

export default class extends Controller {
  static targets = [
    'resultHeaderContainer',
    'resultContainer',
    'sponsoredContainer',
    'asOfDate'
  ]

  connect() {
    this.__renderSearchHeader()
    this.__renderSponsoredRows()
    this.__renderTooltips();
    this.__renderDate();
  }

  handleInput = _.debounce(e => {
    const { target } = e;
    const { value } = target;
    EventManager.emit('mitre-ad-refresh', {
      adNames: ['SR-10-AX', 'SR-11-AX', 'SR-12-AX', 'SR-17-AX']
    })
    this.__renderSearchResult(value)
  }, 300)

  __renderSearchHeader = () => {
    if (this.hasResultHeaderContainerTarget) {

      const container = document.createElement('div')
      container.setAttribute('data-controller', 'component-render');
      container.setAttribute('data-component-render-type', 'append')
      container.setAttribute('data-component-render-url', '/api/components/search-result-header/')
      container.setAttribute('data-component-render-url-method', 'post');
      container.setAttribute('data-component-render-url-data', JSON.stringify({ deviceType: Utility.getDeviceType(), position: 'header' }))
      container.classList.add('t-w-full', 't-flex', 't-max-w-1680')
      this.resultHeaderContainerTarget.innerHTML = '';
      this.resultHeaderContainerTarget.appendChild(container);
      document.getElementById('full-screen-search-input').focus();
    }
  }

  __renderSearchResult = data => {
    if (this.hasResultContainerTarget) {
      const container = document.createElement('div')
      container.setAttribute('data-controller', 'component-render');
      container.setAttribute('data-component-render-type', 'append')
      container.setAttribute('data-component-render-url', '/api/components/search-result/')
      container.setAttribute('data-component-render-url-method', 'post');
      container.setAttribute('data-component-render-url-data', JSON.stringify({ searchText: data, deviceType: Utility.getDeviceType(), position: 'index' }))
      container.setAttribute('data-event-name', 'search-result');
      container.classList.add('t-w-full', 't-flex', 't-max-w-1680')
      const wrapper = document.createDocumentFragment();
      wrapper.appendChild(container);
      morphDom(this.resultContainerTarget.firstChild, wrapper);
    }
  }
  __renderSponsoredRows = () => {
    if (this.hasSponsoredContainerTarget) {
      const container = document.createElement('div')
      container.setAttribute('data-controller', 'component-render');
      container.setAttribute('data-component-render-type', 'append')
      container.setAttribute('data-component-render-url', '/api/components/search-result-sponsored/')
      container.setAttribute('data-component-render-url-method', 'post');
      container.setAttribute('data-component-render-url-data', JSON.stringify({ deviceType: Utility.getDeviceType(), position: 'sponsored-row' }))
      container.classList.add('t-w-full', 't-flex', 't-max-w-1680')
      this.sponsoredContainerTarget.innerHTML = '';
      this.sponsoredContainerTarget.appendChild(container);
    }
  }

  __renderTooltips = () => {
    let el = this.element;
    delegate(el, {
      onShow(instance) {
        const reference = instance.reference;
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        instance.setContent(template.innerHTML);
      },
      target: '.dynamic-tooltip',
      allowHTML: true,
      interactive: true,
      maxWidth: 240,
      theme: 'light',
      placement: 'bottom'
    })
  }

  __renderDate = () => {
    EventManager.on('search-result-appended', () => {
      if (this.asOfDateTarget) {
        const first = this.resultContainerTarget.querySelector('[data-price-as-of]');
        if (first) {
          const datestr = first.dataset.priceAsOf;
          this.asOfDateTarget.classList.remove('t-hidden');
          this.asOfDateTarget.innerHTML = `As of ${datestr}`;
        } else {
          this.asOfDateTarget.classList.add('t-hidden');
        }
      }
    });
  }
}
